export default class CoordinatesModel {    
    latitude: number = 0;
    longitude: number = 0;
    

    static from(json: string): CoordinatesModel {
        let model = Object.assign(new CoordinatesModel(), json);
        return model;
    }
}